import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Spinner } from 'react-bootstrap';

interface QueryResultProps {
  loading: boolean;
  // error: Error | null;
  children: ReactNode;
}

const SpinnerContainer = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100%'
});

const QueryResult = ({ loading, children }: QueryResultProps) => {
  if (loading) {
    return (
      <SpinnerContainer>
        <Spinner animation="border" />
      </SpinnerContainer>
    );
  }

  return <>{children}</>;
};

export default QueryResult;
